import { useTheme } from 'next-themes';
import { useEffect } from 'react';
import { useGetSpaceQuery } from '../store';

const SPACE_ID_THEME_STORAGE_KEY = 'spaceThemes';

const getSpaceThemeFromStorage = (spaceID: string) => {
  const themeSpace = localStorage.getItem(SPACE_ID_THEME_STORAGE_KEY);
  const themeSpaceMap = themeSpace ? JSON.parse(themeSpace) : {};

  return themeSpaceMap[spaceID];
};

// Upon spaceID change check the theme in space customization, and apply it to editor
const useThemeFromSpace = (spaceID: string) => {
  const { theme, setTheme } = useTheme();

  const { data: space } = useGetSpaceQuery([spaceID]);

  useEffect(() => {
    if (!theme) return;

    const themeSpace = localStorage.getItem(SPACE_ID_THEME_STORAGE_KEY);
    const themeSpaceMap = themeSpace ? JSON.parse(themeSpace) : {};
    const storageTheme = themeSpaceMap[spaceID];

    if (storageTheme !== theme) {
      localStorage.setItem(
        SPACE_ID_THEME_STORAGE_KEY,
        JSON.stringify({ ...themeSpaceMap, [spaceID]: theme })
      );
    }
  }, [theme]);

  useEffect(() => {
    if (!spaceID) return;

    const storageTheme = getSpaceThemeFromStorage(spaceID);
    if (storageTheme) setTheme(storageTheme);
  }, [spaceID]);

  useEffect(() => {
    const themeSpace = localStorage.getItem(SPACE_ID_THEME_STORAGE_KEY);
    const themeSpaceMap = themeSpace ? JSON.parse(themeSpace) : {};

    if (
      space?.id &&
      space?.customization?.theme &&
      spaceID &&
      spaceID === space.id &&
      !themeSpaceMap[spaceID]
    ) {
      setTheme(space.customization.theme);
      localStorage.setItem(
        SPACE_ID_THEME_STORAGE_KEY,
        JSON.stringify({ ...themeSpaceMap, [spaceID]: space.customization.theme })
      );
    } else if (themeSpaceMap[spaceID]) {
      setTheme(themeSpaceMap[spaceID]);
    } else {
      setTheme('light');
    }
  }, [spaceID, space]);
};

export default useThemeFromSpace;
